import { CURRENCIES } from 'shared/consts';

import { ELanguages } from '../enums/languages.enum';

export enum EPopups {
	ONBOARDING = 'onboarding',
	TELEGRAM = 'telegram_bot',
}
type TBalance = {
	approved_amount: string;
	balance_amount: string;
	currency: keyof ReturnType<typeof CURRENCIES>;
};
type TUser = {
	user_id: string;
	email: string;
	language: ELanguages;
	balance: TBalance;
	not_shown_popups: EPopups[];
};

export interface IAppConfig {
	is_super_login: boolean;
	payouts_available: boolean;
	mitgo_create_adspace_url: string;
	adspaces_url: string;
	user: TUser | null;
}
